<template>
		<el-dialog title="新建/编辑产品分类" :visible.sync="visible" :before-close="beforeClose" width="50%">
			<el-form
      :inline="true"
      :model="addNewSourceForm"
      label-width="150px"
      label-position="right"
      style="overflow-y: scroll; height: 30vh"
    >
      <el-row>
        <el-form-item label="分类名称">
          <el-input v-model="addNewSourceForm.cateName"></el-input>
        </el-form-item>		
        <el-form-item label="显示顺序">
          <el-input v-model="addNewSourceForm.orderId"></el-input>
        </el-form-item>		
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="$emit('update:visible', false)">返回</el-button>
      <el-button type="primary" @click="onConfirm">确定</el-button>
    </div>
		</el-dialog>

</template>


<script>
import { mapGetters } from "vuex";
import { getToken } from "@/utils/auth";
import MyUploadFileFormItem from "@/components/MyUploadFileFormItem";

export default {
  name: "AddNewSourceDialog",
  components: { MyUploadFileFormItem }, //,todoItem,  SourcePrice
  computed: { ...mapGetters([]) },

  props: {
    visible: { type: Boolean, default: false, required: true },
    formExtra: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  watch: {
    visible(newValue) {   
      if (newValue) {
        if (this.formExtra.cateId){
          this.addNewSourceForm = this.formExtra;
        }
        console.log('bb',this.addNewSourceForm);
      }
    },
  },
  data() {
    return {
      addNewSourceForm: {
        cateId: "",
        cateName: "",
        orderId:"",
      },
    };
  },
  async beforeCreate() {
        
  },
  methods: {
      
    async onConfirm() {
      
      const {
				cateName,orderId
            } = this.addNewSourceForm;
        if (!cateName?.trim()) {
          this.$message.warning('请输入分类名称')
          return;
        }
        if (!orderId) {
          this.$message.warning('请输入显示顺序')
          return;
        }
	 
      
      await this.$store.dispatch("setting/categoryModify", {
        form: this.addNewSourceForm,
      });
      this.$message.success("编辑成功");
      await this.$store.dispatch("setting/categoryList");
      // await this.$store.dispatch('products/sourceAnalysisSimple');
      this.beforeClose();
    },

    beforeClose() {
      this.$emit("update:visible", false);
    },

  },
};
</script>

<style scoped>

</style>